import React from 'react';
import { Kicker } from '../components/ui';

// TODO: move to filtered DB view if needed
const TIMELINE: Array<{ range: string; role: string }> = [
  { range: '2022—now', role: 'Building AI Solutions' },
  { range: '2017—now', role: 'Delivery Lead · Fortune 10 Tech' },
  { range: '2011—17',  role: 'Enterprise Systems · Federal & Commercial' },
  { range: 'pre-2011', role: 'U.S. Army · Combat Veteran' },
];

const CURRENTLY: Array<{ label: string; value: string }> = [
  { label: 'currently shipping', value: 'The Workaround · Coradew · BidWin' },
  { label: 'currently teaching', value: 'Scaffold · cohort-based AI context engineering' },
  { label: 'currently reading',  value: '"Working in Public"' },
  { label: 'off the clock',      value: 'Hornets fan (yes, still). Aspiring pitmaster. Professional dad-joker.' },
];

const AboutPage: React.FC = () => {
  return (
    <div className="max-w-content mx-auto px-s6 md:px-s12 py-s16 grid lg:grid-cols-[1.2fr_1fr] gap-s12 lg:gap-s16">
      <div>
        <Kicker>about · since 2000</Kicker>
        <h1 className="font-mono text-[36px] md:text-[42px] font-medium tracking-[-1.1px] mt-[14px] mb-s5 text-text">
          I build product in Charlotte.
        </h1>
        <p className="text-[16px] text-text-muted leading-[1.65] max-w-[520px]">
          I like the part where the thing starts working. I especially like the part
          where someone uses it and tells me it's wrong. That's the part I keep
          showing up for.
        </p>
        <p className="text-[16px] text-text-muted leading-[1.65] max-w-[520px] mt-s4">
          AI systems. Context engineering. The boring infrastructure that makes
          smart systems possible.
        </p>

        <div className="mt-s10">
          <div className="font-mono text-[10px] text-text-dim uppercase tracking-[1px] mb-s3">
            timeline
          </div>
          {TIMELINE.map(r => (
            <div
              key={r.range}
              className="grid [grid-template-columns:120px_1fr] py-s3 border-t border-border font-mono text-[13px]"
            >
              <span className="text-accent">{r.range}</span>
              <span className="text-text">{r.role}</span>
            </div>
          ))}
        </div>
      </div>

      <aside className="lg:sticky lg:top-[96px] lg:self-start">
        <div className="font-mono text-[10px] text-text-dim uppercase tracking-[1px] mb-s3">
          currently
        </div>
        <div className="font-mono text-[12px] leading-[1.7] grid gap-s3">
          {CURRENTLY.map(({ label, value }) => (
            <div key={label}>
              <div className="text-accent-alt-ink uppercase tracking-[0.6px] text-[10px]">{label}</div>
              <div className="text-text">{value}</div>
            </div>
          ))}
        </div>
      </aside>
    </div>
  );
};

export default AboutPage;
